// Libs
import React from 'react';
// Components
import { Notifications, Wrapper, Title } from 'components';
// Styles
import './index.css';

export const CustomToolbar = ({ left, title, right, selectNotification }) => {
	return (
		<Wrapper padding='0' width='100%' height='56px' mediumBackground>
			{/* LEFT */}
			{left && <Wrapper padding='0'>{left}</Wrapper>}

			{/* CENTER */}
			{title && (
				<Wrapper padding='0' margin='0 0 0 5px' width='100%'>
					<Title>{title}</Title>
				</Wrapper>
			)}

			{/* RIGHT */}
			<Wrapper padding='0'>
				{right}
				{/* Notifications */}
				<Notifications selectNotification={selectNotification} />
			</Wrapper>
		</Wrapper>
	);
};

export function CustomSearchToolbar({ left }) {
	return (
		<Wrapper padding='0' width='100%' height='56px' mediumBackground>
			{left}
		</Wrapper>
	);
}

export const BackComponent = ({ handleOnClick }) => (
	<BackIcon onClick={handleOnClick} />
);
